export enum RoutePath {
  HOME = '/',
  EXPERIENCE = '/experience',
  SKILLS = '/skills',
  PROJECTS = '/projects',
  CONTACTS = '/contacts',
}
